import { FC, memo } from 'react';

import { AppAutocomplete } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteSiteGroupsSitesQuery } from '@/modules/SiteGroups/queries';

export const SiteGroupsSitesAutocomplete: FC<AppAutocompleteComponentProps> = memo((props) => {
  return (
    <AppAutocomplete<typeof useAutocompleteSiteGroupsSitesQuery>
      { ...props }
      notFoundDescription="Немає сайтів з доменами та акаунтом Search Console"
      placeholder="Знайдіть сайт"
      query={ useAutocompleteSiteGroupsSitesQuery }
      options={ (data) => parseSelectData(data, { value: 'id', label: 'name' }) }
    />
  );
});
